import {AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {BacnetDataPoint} from "../../../../domain/device.interface";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {BacnetDeviceService} from "../../../../services/bacnet-device.service";
import {BacnetDataPointAPI} from "../../../../domain/bacnet-datapoint";
import {EventBrokerService} from "../../service/event-broker.service";
import {BACNET_TAB_DATAPOINT_TAB_SELECTED_EVENT} from "../../gateway-details.component";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'eis-gateway-bacnet-polled-datapoint-details',
  templateUrl: './bacnet-polled-datapoint-details.component.html',
  styleUrls: ['./bacnet-polled-datapoint-details.component.scss']
})
export class BacnetPolledDatapointDetailsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  public displayedColumns: string[] = ['online', 'deviceId', 'key', 'dataType', 'description', 'lastValue', 'unit', 'pollingIntervalSeconds', 'lastUpdated']

  @Input()
  datapoints: BacnetDataPoint[];

  @Input()
  gatewaySerial!: string;

  @Input()
  tenant: string;

  @ViewChild(MatSort) sort: MatSort;

  datapointsDataSource: MatTableDataSource<BacnetDataPoint> = new MatTableDataSource<BacnetDataPoint>();
  loadingInProgress: boolean;
  // private tabSelectedSubscription: Subscription;
  private destroy$ = new Subject<void>();


  constructor(private bacnetService: BacnetDeviceService,
              private eventBrokerService: EventBrokerService,) {
  }


  ngAfterViewInit(): void {
    this.datapointsDataSource.sort = this.sort;
  }

  ngOnInit(): void {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.gatewaySerial && this.tenant) {
      this.loadData()


      this.eventBrokerService.eventObserveble$
        .pipe(takeUntil(this.destroy$))
        .subscribe(eventType => {
          if (eventType === BACNET_TAB_DATAPOINT_TAB_SELECTED_EVENT) {
            this.loadData()
          }
        })
    }
  }


  ngOnDestroy(): void {
    console.log("ngOnDestroy...")
    this.destroy$.next()
  }

  private loadData() {
    this.datapointsDataSource.data = []
    this.loadingInProgress = true

    this.bacnetService.getDeployedDatapointsByGatewaySerial(this.gatewaySerial, this.tenant)
      .subscribe(data => {
        this.datapointsDataSource.data = data.map(it => this.toCoreModel(it))
        this.loadingInProgress = false
      })
  }

  toCoreModel(it: BacnetDataPointAPI): BacnetDataPoint {
    return {
      deploymentStatus: "",
      id: it.id,
      deviceId: it.deviceName,
      dataType: it.objectName,
      key: it.key,
      value: it.value,
      unit: it.units,
      description: it.description,
      pollingIntervalSeconds: it.pollingIntervalSeconds,
      lastValue: it.lastValue,
      lastUpdated: it.lastUpdated,
      isOnline: it.isOnline,
    }
  }


}
